import en, { TranslationMessages } from './en';
import flattenMessages from '@liveauctioneers/caterwaul-components/lib/utils/flattenMessages';

/* eslint-disable sort-keys/sort-keys-fix, max-len */
const ja: TranslationMessages = {
    // bidding console
    bidding_console: {
        console: {
            button: {
                login: 'ログインして入札',
                signup: 'サインアップして入札',
                register_long: 'オークションへの登録',
                pending: '登録保留中',
                declined: '登録拒否',
                closed: 'オークション終了',
                sent: '入札されました',
                outbid: 'あなたより高い入札がありました、{amount}さらに入札しますか?',
                bid: '{amount}の入札',
                winning: 'あなたは勝っている',
                // needed
                addPaymentMethod: 'Add Payment to Place Bid',
                approved_limited: "You're approved to bid up to {limit} and have {balance} remaining.",
                backToLiveItem: 'Back To Live Item',
                bidding_locked: 'Bidding Locked',
                bidding_unlocked: 'Bidding Unlocked',
                hide_settings: 'Hide Settings',
                limit_exceeded: 'This item would exceed your bid limit of {limit}',
                show_settings: 'Show Settings',
                suspended: 'Account Suspended',
                waiting: 'Still waiting on approval?',
            },
            // needed
            currentLiveItem: {
                auctioneerInfo: {
                    buttons: {
                        askAQuestion: 'Ask a Question',
                        follow: 'Follow',
                        following: 'Following',
                        followingAuctioneer: 'Following Auctioneer',
                        followAuctioneer: 'Follow Auctioneer',
                    },
                },
                buyersPremium: {
                    middleLowCutOff: '{middle}% above',
                    middleCutOff: '{middle}% up to',
                    highCutOff: '{high}% above',
                    lowCutOff: '{low}% up to',
                    lowPercentage: '{low}%',
                },
                curator: {
                    curatedBy: 'Auction Curated By',
                },
                headers: {
                    buyersPremium: "Buyer's Premium",
                    condition: 'Condition',
                    description: 'Description',
                    dimensions: 'Dimensions',
                    itemDetails: 'Item Details',
                    weight: 'Weight',
                },
            },
            conversions: {
                lot_number: 'ロット{lotNumber}',
            },
            description: {
                estimate_range: '予想金額{low}~{high}',
                images_label: '{currentImageNumber}/{totalImages}',
                // needed
                single_estimate: 'Est. {number}',
                currentBid: 'Current Bid: {amount}',
                convertedBid: 'Conversion: {amount}',
            },
            // needed
            lotTracker: {
                bid: 'Bid',
                bids: 'Bids',
                liveNow: 'Live Now',
                soldFor: 'Sold for',
                passed: 'Passed',
            },
            messages: {
                ask_price_changed_to: 'Ask Price Changed: {amount}{converted}',
                competing_bid_amount: '{amount}{converted}: 競合の入札',
                competing_bidder_outbid_by_liveauctioneers_absentee:
                    '入札者{paddleNumber}の予約入札が競合の入札者より高い入札を行いました',
                last_bid_retracted: '最後の{amount}{converted}の入札は取り消されました',
                liveauctioneers_bid_amount: '{amount}{converted}: ライブオークション 入札者 {paddleNumber}',
                liveauctioneers_bid_amount_absentee:
                    '{amount}{converted}: ライブオークション 入札者 {paddleNumber}の予約入札',
                lot_number_passed: 'ロット{lotNumber}は通過しました',
                lot_number_reopened: 'ロット{lotNumber}は再オープンしました',
                lot_number_skipped: 'ロット{lotNumber}はスキップされました',
                lot_number_unsold: 'ロット{lotNumber}は落札されていません',
                lot_opened_asking: 'ロット番号{lotNumber}が始まりました - {amount}{converted}入札しますか？',
                lot_sold_competing_bidder: 'ロット{lotNumber}は競合入札者に{amount}{converted}で落札されました',
                lot_sold_liveauctioneers_bidder:
                    'ロット{lotNumber}は入札者{paddleNumber}に{amount}{converted}で落札されました',
                my_bid_amount: '{amount}{converted}: 入札',
                my_bid_amount_absentee: '{amount}{converted}: 予約入札',
                my_bid_retracted: 'あなたの{amount}{converted}の入札は取り消されました',
                registration_approved: '無事登録されました',
                reserve_not_met: '最低落札価格に未到達',
                you_been_outbid_by_liveauctioneers_absentee: '入札者{paddleNumber}があなたより高い入札を行いました',
                you_ve_won_lot: 'ロット{lotNumber}はあなたに落札されました',
                // needed
                bid_limit_exceeded: 'Your bid limit exceeded',
                limited_approval: 'Approved to bid up to: {limit}',
                paused: 'Auction Paused',
            },
            // needed
            settingsMenu: {
                headerText: 'Settings',
                language: 'Language',
                currency: 'Currency',
            },
            missives: {
                fair_warning_lot_about_to_close: 'このオークションは間もなく終了します',
                going_once_going_twice: 'さらに入札はしますか？',
                third_and_final_warning: '最後のチャンスです、入札はしますか？',
            },
            status: {
                remaining: '{total}ロット中残り{remaining}ロット',
                // needed
                nextBid: {
                    text: 'My Next Bid',
                    value: '{total} Away',
                },
                nextFavorite: {
                    text: 'My Next Favorite',
                    value: '{total} Away',
                },
            },
            thumbnail_scroller: {
                next: '次のロット',
            },
            // needed
            lockText: {
                locked: 'Unlock to Bid',
                unlocked: 'Bidding Unlocked',
            },
            mobileHeader: {
                title: '{lotNumber}: {title}',
            },
            mobileFooter: {
                itemSaves: '{savedCount}',
            },
        },
        // needed
        explainer_modal: {
            title: 'Welcome to the Auction',
            subtext: 'Good luck! Please review some auction details.',
            fee_disclaimer:
                'The price of your bid does not include potential fees, such as a buyer’s premium, taxes, shipping, or processing fee',
            autopay_disclaimer: 'You will be charged the full price shortly after the conclusion of the auction',
            shipping_disclaimer: 'Shipping details can be found in this auction’s Shipping, Payment & Auction Policies',
            button: 'Got it',
        },
        wait: {
            title: 'Stay tuned. Auction will begin shortly',
            status_message: "{name} is delighted you're here!",
            login_button_text: 'Log In',
            register_button_text: 'Register for Auction',
            image_slider_text: 'Popular Lots in This Auction',
            hidden_text: 'View the Catalog',
            card: {
                title: 'Lot {lotNumber}: {title}',
                bid: 'Bid',
                bids: 'Bids',
            },
        },
        done: {
            title: '{title} has ended',
            status_message: 'Follow {name} to hear about their next auction.',
            live_catalogs_title: 'View Other Live Auctions',
            upcoming_catalogs_title: 'Upcoming Auctions',
        },
    },
};

export default { ...en, ...flattenMessages(ja) };
